import { useEffect } from "react";
import { useForm } from "@inertiajs/react";
import StepForm from "@/pages/steps/step-form";
import { buildStepFormData, serializeStep } from "@/pages/steps/form-utils";
import { handleDrawerSuccess, hasArrayErrors } from "@/lib/drawer-submission";

export default function StepCreateDrawer({ step, templates = [], errors = [], createPath, onSuccess, onProcessingChange = null }) {
  const { data, setData, post, processing, transform } = useForm(buildStepFormData(step));

  useEffect(() => {
    setData(buildStepFormData(step));
  }, [setData, step]);

  useEffect(() => {
    onProcessingChange?.(processing);
  }, [onProcessingChange, processing]);

  const submit = (event) => {
    event.preventDefault();
    transform(() => ({ step: serializeStep(data.step) }));
    post(createPath, {
      preserveScroll: true,
      onSuccess: (page) => handleDrawerSuccess(
        page,
        (props) => props.show_create_step_drawer || hasArrayErrors(props, "step_errors"),
        onSuccess
      ),
    });
  };

  return (
    <StepForm
      data={data}
      setData={setData}
      templates={templates}
      errors={errors}
      processing={processing}
      onSubmit={submit}
      submitLabel="Opret trin"
      layout="drawer"
    />
  );
}
